import { Box, Typography } from '@mui/material'
import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import users from '../Models/TestData'
import QRCode from 'qrcode'

export default function IdCard() {
    const param=useParams();
    const [qr,setQr]=useState()
    const createQR=()=>{
        QRCode.toDataURL(`https://astha-bd.web.app/id/${param.id}`).then((url)=>{
            setQr(url)
        })
    }
    useEffect(()=>{
        createQR()
    })
 
    var user=users[param.id]
  return (
    <Box  sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",width:"100vw", minHeight:"100vh",backgroundColor:"#f4f4f4",marginTop:{md:"7vh"}}}>
        {!user && <Typography variant="h4" color="error.main">User is NOT verified</Typography>}
        {user && <Typography variant="h4" color="success.main">User is verified</Typography>}
        {user && <Box sx={{border:"5px solid #5d4037",width:{xs:"80vw",md:"60vw",lg:"45vw"},minHeight:"30vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",marginTop:"5vh"}}>
        <Box sx={{width:{xs:"70vw",md:"50vw",lg:"40vw"},marginTop:"2vh",marginBottom:"2vh",display:"flex",alignItems:"center",justifyContent:"center"}}>
            <Typography variant="h5" color="#5d4037">Refugee ID card</Typography>
        </Box>
            <Box sx={{display:"flex",alignItems:"center",justifyContent:"space-between",width:{xs:"70vw",md:"50vw",lg:"40vw"},marginBottom:"2vh"}}>
                <Box component="img" src={user.imgUrl} sx={{width:{xs:"66px",md:"100px"},height:{xs:"66px",md:"100px"}}}/>
                <Box component="img" src={qr} sx={{width:{xs:"66px",md:"100px"},height:{xs:"66px",md:"100px"}}}/>
            </Box>
            <Box sx={{width:{xs:"70vw",md:"50vw",lg:"40vw"}}}>
                <Typography>Name : {user.name}</Typography>
                <Typography>Father's Name : {user['father\'s_name']}</Typography>
                <Typography>Mother's Name : {user['mother\'s_name']}</Typography>
                <Typography>Residence : {user.residence}</Typography>
            </Box>
            <Box sx={{width:{xs:"70vw",md:"50vw",lg:"40vw"},marginTop:"2vh",marginBottom:"2vh"}}>
                <Typography color="error.main">This ID was automatically generated by ASTHA-BD</Typography>
                
            </Box>
        </Box>}
        
    </Box>
  )
}
